module.exports = __webpack_public_path__ + "img/image01-left.39af9307.png";